export const AppSettingKey = {
  LIVE_CHAT_CONTACT_PERSON_ID: 'live-chat-contact-person-id'
} as const

export type AppSettingKey = (typeof AppSettingKey)[keyof typeof AppSettingKey]

export interface AppSettingValueMap {
  [AppSettingKey.LIVE_CHAT_CONTACT_PERSON_ID]: number
}

export interface AppSetting<K extends AppSettingKey = AppSettingKey> {
  id: number
  key: K
  value: AppSettingValueMap[K]
}
